import contentRu from '../commonContentRu.yml';
import contentEn from '../commonContentEn.yml';
import contentCn from '../commonContentCn.yml';


const commonContentListDocsRu = {
    title: contentRu[0].title,
    welcome: contentRu[1].title,
    welcomeSpan: contentRu[2].title,
    search: contentRu[3].title,
};

const commonContentListDocsEn = {
    title: contentEn[0].title,
    welcome: contentEn[1].title,
    welcomeSpan: contentEn[2].title,
    search: contentEn[3].title,
};

const commonContentListDocsCn = {
    title: contentCn[0].title,
    welcome: contentCn[1].title,
    welcomeSpan: contentCn[2].title,
    search: contentCn[3].title,
};


export {
    commonContentListDocsRu,
    commonContentListDocsEn,
    commonContentListDocsCn,
};
